import React, { useMemo, useCallback } from "react";
import PropTypes from "prop-types";
import HpoItem from "./HPOItem";

function HPOTree(props) {
  const { HPOTree: hpoTree, geneSymbol, checkBoxes } = props;
  const { hpo: hpoArr } = hpoTree || {};

  const hpos = useMemo(
    () =>
      (Array.isArray(hpoArr) ? hpoArr : []).map((x, i) => ({
        ...x,
        key: `${i}-${new Date()}`,
      })),
    [hpoArr]
  );

  const constructId = useCallback((x, i) => {
    return (
      x.disease_id || x.phenotype_id || x.phenotype_name || x.disease_name || i
    );
  });

  return (
    <div className="tw-text-xs">
      {geneSymbol && Array.isArray(hpoArr) ? (
        <HpoItem
          {...props}
          type="gene"
          style={{ color: "white" }}
          checkBoxes={checkBoxes}
          item={{ phenotype_name: geneSymbol, phenotype_id: geneSymbol }}
        />
      ) : null}

      {hpos.map((hpo) => {
        const diseases = hpo.diseases || [];
        const phenotypes = hpo.phenotypes || [];
        return (
          <div key={`${hpo.key}-hpos-external`}>
            {diseases.map((x, i) => (
              <HpoItem
                {...props}
                key={`${constructId(x, i)}-hpo-diseases-${i}`}
                type="disease"
                checkBoxes={checkBoxes}
                item={x}
              />
            ))}
            {phenotypes.map((x, i) => (
              <HpoItem
                {...props}
                key={`${constructId(x, i)}-hpo-phenotypes-${i}`}
                type="phenotype"
                checkBoxes={checkBoxes}
                item={x}
              />
            ))}
          </div>
        );
      })}
    </div>
  );
}

HPOTree.propTypes = {
  HPOTree: PropTypes.shape({
    hpo: PropTypes.arrayOf(
      PropTypes.shape({
        diseases: PropTypes.arrayOf(PropTypes.shape({})),
        phenotypes: PropTypes.arrayOf(PropTypes.shape({})),
      })
    ),
  }),
  geneSymbol: PropTypes.string,
  checkBoxes: PropTypes.bool,
};

HPOTree.defaultProps = {
  HPOTree: null,
  geneSymbol: null,
  checkBoxes: false,
};

export default React.memo(HPOTree);
